import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap";

function useFonts() {
  useEffect(() => {
    if (document.querySelector('link[href*="Instrument+Serif"]')) return;
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = FONTS_URL;
    document.head.appendChild(l);
  }, []);
}

const T = {
  g700: "#155c36", g600: "#1b7a47", g500: "#1e9254", g400: "#28b566",
  g200: "#a7d9bc", g100: "#d6f0e3", g50: "#eef8f3",
  n900: "#0f1117", n800: "#1c2130", n700: "#2d3549", n600: "#4a5268",
  n400: "#8a93a8", n300: "#b0b8cc", n200: "#d1d5e0", n150: "#e4e7ef",
  n100: "#eef0f5", n50: "#f7f8fa", white: "#ffffff",
  amber: "#d97706", amberBg: "#fffbeb", amberBorder: "#fde68a", amberText: "#92400e",
  blue: "#2563eb", blueBg: "#eff6ff", blueBorder: "#bfdbfe",
  serif: "'Instrument Serif', Georgia, serif",
  sans:  "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

const Icon = ({ name, size = 20, color = "currentColor", strokeWidth = 1.6 }) => {
  const paths = {
    ArrowLeft:     <><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></>,
    ArrowRight:    <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></>,
    ChevronRight:  <><path d="m9 18 6-6-6-6"/></>,
    Search:        <><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></>,
    MapPin:        <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></>,
    Star:          <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    BadgeCheck:    <><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></>,
    Calendar:      <><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></>,
    Clock:         <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    Wallet:        <><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4Z"/></>,
    ShieldCheck:   <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></>,
    Droplets:      <><path d="M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z"/><path d="M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97"/></>,
    Wrench:        <><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></>,
    AlertTriangle: <><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3z"/><path d="M12 9v4M12 17h.01"/></>,
    Flame:         <><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></>,
    Phone:         <><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.34 3h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.09a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></>,
    Home:          <><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>,
    Lock:          <><rect width="18" height="11" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>,
    User:          <><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></>,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
};

/* ─────────────────────────────────────────
   DATA
───────────────────────────────────────── */

const SUBSERVICES = [
  { icon: "Droplets", label: "Leak repair",             range: "KES 1,000 – 4,000",  note: "per job" },
  { icon: "Wrench",   label: "Pipe & fitting repair",   range: "KES 1,500 – 6,000",  note: "per job" },
  { icon: "Flame",    label: "Geyser & water heater",   range: "KES 2,500 – 9,000",  note: "install or repair" },
  { icon: "Home",     label: "Bathroom installation",   range: "KES 5,000 – 25,000", note: "per fixture" },
  { icon: "AlertTriangle", label: "Blocked drains",     range: "KES 1,500 – 5,000",  note: "per job" },
  { icon: "Wallet",   label: "Water tank cleaning",     range: "KES 2,000 – 7,000",  note: "per tank" },
];

const HOW_IT_WORKS = [
  { num: "01", icon: "Search",   title: "Describe the problem",      desc: "Tell us what's wrong — a leak, a blockage, an installation — and your location. Takes under a minute." },
  { num: "02", icon: "User",     title: "Compare verified plumbers", desc: "See ratings, reviews, pricing, and real availability before you choose who comes to your home." },
  { num: "03", icon: "Calendar", title: "Book a time that works",    desc: "Same-day slots are available for urgent jobs. Confirm the time and any access details in-app." },
  { num: "04", icon: "Wallet",   title: "Pay only once it's fixed",  desc: "Funds are held securely and released to the plumber only after you confirm the job is done." },
];

const WHY_POINTS = [
  { icon: "BadgeCheck",  title: "Every plumber is verified",     desc: "ID-checked and background-reviewed before they ever appear in search results. No exceptions." },
  { icon: "Star",        title: "Reviews tied to real bookings",  desc: "Every rating comes from a completed, paid booking. No anonymous or fake reviews ever make it onto a profile." },
  { icon: "ShieldCheck", title: "Covered by the Jirani Guarantee", desc: "If a repair fails or work is incomplete, our Trust and Safety team reviews it, including refunds where warranted." },
  { icon: "Wallet",      title: "Pay only when it's fixed",       desc: "Funds are held securely and only released to the plumber after you confirm the work meets what was agreed." },
];

const EMERGENCY_SIGNS = [
  "Water actively flooding a room or pooling near electrical outlets",
  "A burst pipe you cannot stop with the main shutoff valve",
  "Sewage backing up into sinks, showers, or toilets",
  "No water supply to the entire property with no known cause",
  "A gas water heater that smells of gas or will not shut off",
];

const FAQS = [
  {
    q: "How much does a plumber cost in Kenya through JiraniApp?",
    a: "Most call-out repairs such as leak fixes or pipe repairs range from KES 1,000 to 6,000 depending on complexity and materials needed. Larger jobs like bathroom installations or geyser replacements can run from KES 5,000 to 25,000 or more. Every JiraniPro lists their own rates on their profile, and many offer a free or low-cost site assessment for larger jobs before confirming a final price.",
  },
  {
    q: "Can I get a plumber the same day for an urgent issue?",
    a: "Yes. Many plumbers on JiraniApp list same-day availability, and you can filter search results specifically by availability today. For genuine emergencies — active flooding, burst pipes, sewage backup — book the nearest available verified plumber and message them directly to flag the urgency.",
  },
  {
    q: "Do I need to supply materials and parts myself?",
    a: "This varies by plumber and is usually noted on their profile. Many plumbers bring standard parts and fittings and charge for materials separately on the final invoice. For larger jobs like a full bathroom fitting, materials are typically a significant cost and should be discussed and agreed before the work begins.",
  },
  {
    q: "What should I do before the plumber arrives?",
    a: "If you know where your main water shutoff valve is, it helps to mention this to the plumber, though most can locate it themselves. Clear access to the affected area — under sinks, around the water heater, near the main line — speeds up the job. If you do not know where your main shutoff is, ask the plumber to show you once they arrive; it is useful for future emergencies.",
  },
  {
    q: "What happens if the same problem comes back after the repair?",
    a: "Message the plumber directly through the app first — many will return to address a recurring issue at no extra charge if it is within a reasonable period after the original job. If the plumber is unresponsive or the issue is not resolved, you can open a dispute through Help and Support within 48 hours of the original booking for a fair review.",
  },
  {
    q: "Is gas water heater work covered on JiraniApp?",
    a: "Yes, but gas connections specifically should only be handled by a plumber or technician with the relevant qualification, which should be stated on their profile. Never attempt to test, light, or troubleshoot a gas geyser yourself if you smell gas — turn off the supply if it is safe to do so and book a qualified professional immediately.",
  },
];

const TESTIMONIALS = [
  { name: "Kevin M.",  area: "Lavington, Nairobi", text: "Burst pipe under my kitchen sink on a Sunday morning. Had a verified plumber at my door within ninety minutes. Fixed properly, no return visit needed.", rating: 5 },
  { name: "Fatuma R.", area: "Nyali, Mombasa",     text: "Booked a full bathroom retiling and fixture install. The plumber gave me a clear written quote before starting and stuck to it exactly.", rating: 5 },
  { name: "Daniel O.", area: "Kileleshwa, Nairobi",text: "My geyser had been making a strange noise for weeks. Got it serviced and replaced before it actually failed. Glad I did not wait.", rating: 5 },
];

/* ─────────────────────────────────────────
   COMPONENTS
───────────────────────────────────────── */

function SubServiceCard({ icon, label, range, note }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: "20px 18px", borderRadius: 14,
        border: `1.5px solid ${hovered ? T.g200 : T.n150}`,
        background: hovered ? T.g50 : T.white,
        transition: "all .18s", cursor: "default",
      }}>
      <div style={{
        width: 38, height: 38, borderRadius: 10,
        background: hovered ? T.g100 : T.n50,
        border: `1px solid ${hovered ? T.g200 : T.n150}`,
        display: "flex", alignItems: "center", justifyContent: "center",
        marginBottom: 14, transition: "all .18s",
      }}>
        <Icon name={icon} size={17} color={hovered ? T.g600 : T.n400} strokeWidth={1.7} />
      </div>
      <div style={{ fontSize: 14, fontWeight: 600, color: T.n800, marginBottom: 7 }}>{label}</div>
      <div style={{ fontFamily: T.serif, fontSize: 19, fontWeight: 400, color: hovered ? T.g700 : T.n900, letterSpacing: "-0.02em", lineHeight: 1.2 }}>{range}</div>
      <div style={{ fontSize: 11, color: T.n400, marginTop: 3 }}>{note}</div>
    </div>
  );
}

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: `1px solid ${T.n100}` }}>
      <button onClick={() => setOpen(o => !o)} style={{
        width: "100%", textAlign: "left", background: "none", border: "none",
        padding: "22px 0", display: "flex", justifyContent: "space-between",
        alignItems: "center", cursor: "pointer", gap: 20, fontFamily: T.sans,
      }}>
        <span style={{ fontSize: 15, fontWeight: 400, color: T.n800, lineHeight: 1.5, letterSpacing: "-0.01em" }}>{q}</span>
        <span style={{
          width: 28, height: 28, borderRadius: "50%", flexShrink: 0,
          border: `1px solid ${open ? T.g500 : T.n200}`,
          background: open ? T.g500 : "transparent",
          color: open ? T.white : T.n400,
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "all .22s cubic-bezier(.4,0,.2,1)",
          transform: open ? "rotate(45deg)" : "none",
          fontSize: 18, fontWeight: 300, lineHeight: 1,
        }}>+</span>
      </button>
      <div style={{ overflow: "hidden", maxHeight: open ? 400 : 0, transition: "max-height .32s cubic-bezier(.4,0,.2,1)" }}>
        <p style={{ margin: "0 0 22px", fontSize: 15, color: T.n600, lineHeight: 1.75, paddingRight: 48, fontFamily: T.sans }}>{a}</p>
      </div>
    </div>
  );
}

function TestimonialCard({ name, area, text, rating }) {
  const initials = name.split(" ").map(w => w[0]).slice(0, 2).join("");
  return (
    <div style={{ padding: "22px", borderRadius: 16, border: `1px solid ${T.n150}`, background: T.white, display: "flex", flexDirection: "column", gap: 14 }}>
      <div style={{ display: "flex", gap: 2 }}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Icon key={i} name="Star" size={13} color={i < rating ? T.amber : T.n150} strokeWidth={0} />
        ))}
      </div>
      <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.75, margin: 0 }}>"{text}"</p>
      <div style={{ display: "flex", alignItems: "center", gap: 10, paddingTop: 6, borderTop: `1px solid ${T.n100}` }}>
        <div style={{ width: 34, height: 34, borderRadius: "50%", background: T.g50, border: `1.5px solid ${T.g100}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 600, color: T.g700, fontFamily: T.sans }}>{initials}</div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: T.n900 }}>{name}</div>
          <div style={{ fontSize: 11, color: T.n400 }}>{area}</div>
        </div>
      </div>
    </div>
  );
}

/* ══ MAIN PAGE ══ */
export default function PlumbingCategoryPage() {
  useFonts();
  const navigate = useNavigate();
  const [location, setLocation] = useState("");
  const [searchFocused, setSearchFocused] = useState(false);

  const goToSearch = () => {
    const params = location.trim() ? `?category=plumbing&location=${encodeURIComponent(location.trim())}` : "?category=plumbing";
    navigate(`/search${params}`);
  };

  return (
    <div style={{ fontFamily: T.sans, background: T.white, minHeight: "100vh", color: T.n900, paddingBottom: 60 }}>
      <style>{`
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { display: none; }
      `}</style>

      {/* ── Nav ── */}
      <div style={{ padding: "16px 24px", borderBottom: `1px solid ${T.n100}`, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button onClick={() => navigate(-1)} style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "none", border: "none", cursor: "pointer",
          color: T.n400, fontSize: 13, fontFamily: T.sans, padding: 0,
        }}
          onMouseEnter={e => e.currentTarget.style.color = T.n800}
          onMouseLeave={e => e.currentTarget.style.color = T.n400}>
          <Icon name="ArrowLeft" size={14} strokeWidth={2} />
          Back
        </button>
        <button onClick={() => navigate("/pro-onboarding")} style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "none", border: `1px solid ${T.n200}`, cursor: "pointer",
          color: T.n600, fontSize: 13, fontFamily: T.sans,
          padding: "8px 16px", borderRadius: 8, fontWeight: 500,
        }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = T.n400; e.currentTarget.style.color = T.n900; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = T.n200; e.currentTarget.style.color = T.n600; }}>
          Are you a plumber? Join as a Pro
        </button>
      </div>

      {/* ══ HERO ══ */}
      <div style={{ padding: "clamp(52px,7vw,88px) 20px clamp(40px,5vw,56px)", borderBottom: `1px solid ${T.n100}` }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, color: T.g600, fontSize: 12, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 22 }}>
            <Icon name="Droplets" size={13} color={T.g500} strokeWidth={2.2} />
            Plumbing Services
          </div>
          <h1 style={{
            fontFamily: T.serif, fontSize: "clamp(38px,7vw,64px)", fontWeight: 400,
            margin: "0 0 18px", lineHeight: 1.07, color: T.n900, letterSpacing: "-0.03em", maxWidth: 600,
          }}>
            Leaks fixed fast,<br/>
            <em style={{ fontStyle: "italic", color: T.g600 }}>by people who know pipes</em>
          </h1>
          <p style={{ fontSize: "clamp(15px,2vw,17px)", color: T.n600, lineHeight: 1.75, margin: "0 0 32px", maxWidth: 520 }}>
            Book verified, reviewed plumbers across Kenya for leaks, blockages, installations, and emergencies.
            Compare prices, check real availability, and get same-day help when you need it most.
          </p>

          {/* Search bar */}
          <div style={{
            display: "flex", gap: 8, padding: 8, borderRadius: 14,
            background: T.n50, border: `1.5px solid ${searchFocused ? T.g400 : T.n150}`,
            boxShadow: searchFocused ? `0 0 0 4px ${T.g100}` : "0 1px 4px rgba(0,0,0,.04)",
            transition: "all .18s", flexWrap: "wrap",
          }}>
            <div style={{ flex: 1, minWidth: 180, display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: T.white, borderRadius: 10 }}>
              <Icon name="MapPin" size={16} color={T.n400} strokeWidth={1.8} />
              <input
                value={location}
                onChange={e => setLocation(e.target.value)}
                onFocus={() => setSearchFocused(true)}
                onBlur={() => setSearchFocused(false)}
                placeholder="Your area, e.g. Lavington, Nyali..."
                style={{ flex: 1, border: "none", outline: "none", fontSize: 14, fontFamily: T.sans, color: T.n900, background: "transparent" }}
              />
            </div>
            <button onClick={goToSearch} style={{
              display: "inline-flex", alignItems: "center", gap: 7,
              padding: "12px 22px", background: T.g500, color: T.white,
              border: "none", borderRadius: 10, fontSize: 14, fontWeight: 600,
              cursor: "pointer", fontFamily: T.sans, whiteSpace: "nowrap",
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              <Icon name="Search" size={15} color={T.white} strokeWidth={2} />
              Find Pros
            </button>
          </div>
        </div>
      </div>

      {/* ══ TRUST STRIP ══ */}
      <div style={{ borderBottom: `1px solid ${T.n100}`, padding: "0 20px" }}>
        <div style={{ maxWidth: 720, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))" }}>
          {[
            { icon: "BadgeCheck", label: "120+ verified plumbers" },
            { icon: "Star",       label: "4.7 average rating across bookings" },
            { icon: "Clock",      label: "Same-day slots available for urgent jobs" },
          ].map(({ icon, label }, i) => (
            <div key={i} style={{ padding: "20px", display: "flex", alignItems: "center", gap: 11, borderRight: i < 2 ? `1px solid ${T.n100}` : "none" }}>
              <Icon name={icon} size={17} color={T.g500} strokeWidth={1.6} />
              <span style={{ fontSize: 13, color: T.n600, lineHeight: 1.4 }}>{label}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 20px" }}>

        {/* ══ EMERGENCY CALLOUT ══ */}
        <div style={{
          marginTop: "clamp(32px,5vw,48px)",
          padding: "20px 22px", borderRadius: 16,
          background: T.amberBg, border: `1.5px solid ${T.amberBorder}`,
          display: "flex", gap: 14, alignItems: "flex-start",
        }}>
          <div style={{
            width: 38, height: 38, borderRadius: 10, flexShrink: 0,
            background: T.white, border: `1px solid ${T.amberBorder}`,
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <Icon name="AlertTriangle" size={17} color={T.amber} strokeWidth={1.8} />
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: T.amberText, marginBottom: 6 }}>
              Is this a plumbing emergency?
            </div>
            <p style={{ fontSize: 13, color: T.amberText, lineHeight: 1.7, margin: "0 0 10px" }}>
              If you are dealing with any of the following, locate your main water shutoff valve first if it is safe to do so, then book the nearest available verified plumber and flag the job as urgent in your message:
            </p>
            <ul style={{ margin: 0, paddingLeft: 18 }}>
              {EMERGENCY_SIGNS.map((sign, i) => (
                <li key={i} style={{ fontSize: 13, color: T.amberText, lineHeight: 1.7, marginBottom: 4 }}>{sign}</li>
              ))}
            </ul>
          </div>
        </div>

        {/* ══ SUB-SERVICES ══ */}
        <div style={{ paddingTop: "clamp(48px,7vw,72px)", marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>What's included</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Every plumbing job, <em style={{ fontStyle: "italic", color: T.g600 }}>covered</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 24px", lineHeight: 1.65 }}>
            From a dripping tap to a full bathroom fit-out. Prices reflect what Pros on the platform are currently charging.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))", gap: 12 }}>
            {SUBSERVICES.map((s, i) => <SubServiceCard key={i} {...s} />)}
          </div>
        </div>

        {/* ══ HOW IT WORKS ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>How it works</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Booked in minutes, <em style={{ fontStyle: "italic", color: T.g600 }}>fixed properly</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 28px", lineHeight: 1.65 }}>
            No phone calls, no back-and-forth. Just clear pricing and verified people.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 14 }}>
            {HOW_IT_WORKS.map((step, i) => (
              <div key={i} style={{ padding: "22px", borderRadius: 14, border: `1px solid ${T.n150}`, background: T.n50, display: "flex", gap: 16, alignItems: "flex-start" }}>
                <div style={{
                  width: 38, height: 38, borderRadius: 10, flexShrink: 0,
                  background: T.white, border: `1px solid ${T.n150}`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                  <Icon name={step.icon} size={17} color={T.g500} strokeWidth={1.6} />
                </div>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.08em", marginBottom: 4 }}>STEP {step.num}</div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: T.n900, marginBottom: 6 }}>{step.title}</div>
                  <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.65, margin: 0 }}>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 24, textAlign: "center" }}>
            <button onClick={goToSearch} style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: T.g500, color: T.white, border: "none",
              padding: "13px 28px", borderRadius: 11, fontSize: 14, fontWeight: 600,
              cursor: "pointer", fontFamily: T.sans,
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Browse plumbers near you
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
          </div>
        </div>

        {/* ══ WHY JIRANIAPP ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Why book through JiraniApp</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 24px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Trust, built into <em style={{ fontStyle: "italic", color: T.g600 }}>every booking</em>
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 14 }}>
            {WHY_POINTS.map((item, i) => (
              <div key={i} style={{ padding: "22px", borderRadius: 14, border: `1px solid ${T.n150}`, display: "flex", flexDirection: "column", gap: 12 }}>
                <div style={{ width: 38, height: 38, borderRadius: 10, background: T.g50, border: `1px solid ${T.g100}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Icon name={item.icon} size={17} color={T.g500} strokeWidth={1.6} />
                </div>
                <div style={{ fontSize: 14, fontWeight: 600, color: T.n900 }}>{item.title}</div>
                <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.7, margin: 0 }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ══ TESTIMONIALS ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>From clients</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 24px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            What people are <em style={{ fontStyle: "italic", color: T.g600 }}>saying</em>
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 14 }}>
            {TESTIMONIALS.map((t, i) => <TestimonialCard key={i} {...t} />)}
          </div>
        </div>

        {/* ══ FAQ ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Common questions</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 4px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Before you <em style={{ fontStyle: "italic", color: T.g600 }}>book</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 8px", lineHeight: 1.65 }}>
            Everything clients usually ask about plumbing bookings.
          </p>
          <div>
            {FAQS.map((item, i) => <FaqItem key={i} {...item} />)}
          </div>
        </div>

        {/* ══ FOOTER CTA ══ */}
        <div style={{ padding: "clamp(36px,5vw,56px)", borderRadius: 20, border: `1px solid ${T.n150}`, textAlign: "center", background: T.n50 }}>
          <div style={{ width: 52, height: 52, borderRadius: 14, background: T.g50, border: `1.5px solid ${T.g200}`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
            <Icon name="Droplets" size={22} color={T.g500} strokeWidth={1.6} />
          </div>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(28px,4.5vw,40px)", fontWeight: 400, color: T.n900, margin: "0 0 12px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Got a leak that <em style={{ fontStyle: "italic", color: T.g600 }}>won't wait?</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 auto 32px", lineHeight: 1.75, maxWidth: 400 }}>
            Compare verified plumbers near you and book in minutes.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={goToSearch} style={{
              padding: "14px 32px", background: T.g500, color: T.white,
              border: "none", borderRadius: 11, fontSize: 15, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
              display: "inline-flex", alignItems: "center", gap: 8,
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Find a plumber
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
            <button onClick={() => navigate("/how-it-works")} style={{
              padding: "14px 28px", background: "transparent", color: T.n700,
              border: `1.5px solid ${T.n200}`, borderRadius: 11, fontSize: 15, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
            }}
              onMouseEnter={e => e.currentTarget.style.borderColor = T.n400}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.n200}>
              Learn how JiraniApp works
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}